import { Box, Typography } from '@mui/material';
import React from 'react';

export const MatchingPropLeadFieldSelectShow = ({ property }) => {
  const { publicLabel, minValue, options, label } = property;

  const selectedOptions = options.filter((obj) =>
    minValue?.includes(obj.value)
  );

  const showString =
    selectedOptions.length > 0
      ? selectedOptions.reduce((acc, el, index) => {
          return (acc += index == 0 ? el.label : ', ' + el?.label);
        }, '')
      : '-';

  return (
    <Box className="flex items-start justify-between gap-2">
      <Typography>{`${publicLabel || label}: `}</Typography>
      <Typography>{`${showString || '-'}`}</Typography>
    </Box>
  );
};
